import type { I18nBundle } from '@/platform/i18n/types';

import { bduiTranslations as enBdui } from './en/bdui';
import { globalTranslations as enGlobal } from './en/global';
import { loginTranslations as enLogin } from './en/login';
import { registerTranslations as enRegister } from './en/register';
import { settingsTranslations as enSettings } from './en/settings';
import { bduiTranslations as esBdui } from './es/bdui';
import { globalTranslations as esGlobal } from './es/global';
import { loginTranslations as esLogin } from './es/login';
import { registerTranslations as esRegister } from './es/register';
import { settingsTranslations as esSettings } from './es/settings';
import { bduiTranslations as ptBdui } from './pt/bdui';
import { globalTranslations as ptGlobal } from './pt/global';
import { loginTranslations as ptLogin } from './pt/login';
import { registerTranslations as ptRegister } from './pt/register';
import { settingsTranslations as ptSettings } from './pt/settings';

/** Namespaces every dashboard ships: shell, auth screens, settings hub, BDUI engine. */
export const coreI18n: I18nBundle = {
  es: {
    global: esGlobal,
    login: esLogin,
    register: esRegister,
    settings: esSettings,
    bdui: esBdui,
  },
  en: {
    global: enGlobal,
    login: enLogin,
    register: enRegister,
    settings: enSettings,
    bdui: enBdui,
  },
  pt: {
    global: ptGlobal,
    login: ptLogin,
    register: ptRegister,
    settings: ptSettings,
    bdui: ptBdui,
  },
};
